// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__7lCNl","footerLink":"Footer_footerLink__s43U9","activeLink":"Footer_activeLink__mZpdI"};